/**
 * Created by kubla on 11/04/17.
 */
import Constants from "../js/constants";
import * as Helpers from "../js/helpers";
import Config from "../../config-app/config";
import Vuex from "vuex";
import db from "../js/db";
import router from "../js/router";

export default {
  data() {
    return {
      ruoli_array: [
        Constants.RUOLO.P,
        Constants.RUOLO.D,
        Constants.RUOLO.C,
        Constants.RUOLO.A,
      ],
      warnBeforeUnload: true,
      defaultPics: [
        "/static/shields/clubs/1.png",
        "/static/shields/clubs/2.png",
        "/static/shields/clubs/3.png",
        "/static/shields/clubs/4.png",
        "/static/shields/clubs/5.png",
        "/static/shields/clubs/6.png",
        "/static/shields/clubs/7.png",
        "/static/shields/clubs/8.png",
        "/static/shields/clubs/9.png",
        "/static/shields/clubs/10.png",
        "/static/shields/flat/1.png",
        "/static/shields/flat/2.png",
        "/static/shields/flat/3.png",
        "/static/shields/flat/4.png",
        "/static/shields/flat/5.png",
        "/static/shields/flat/6.png",
        "/static/shields/flat/7.png",
        "/static/shields/flat/8.png",
        "/static/shields/flat/9.png",
        "/static/shields/flat/10.png",
      ],
    };
  },
  methods: {
    fp_uid(_uid) {
      if (_uid == null) {
        return null;
      }
      return _uid.replace("_", "");
    },
    ruolo(id) {
      return Constants.RUOLI[id];
    },
    ruolo3(id) {
      return Constants.RUOLI3[id];
    },
    ruoloMantra(mantra_id) {
      if (Constants.RUOLI_MANTRA[mantra_id]) {
        return Constants.RUOLI_MANTRA[mantra_id].label;
      }
      return "-";
    },
    ruoloMantraDescr(mantra_id) {
      if (Constants.RUOLI_MANTRA[mantra_id]) {
        return Constants.RUOLI_MANTRA[mantra_id].descr;
      }
      return "-";
    },
    squadra(id) {
      return this.asta_squadre[id];
    },
    calciatore(id) {
      return this.calciatori[id];
    },
    getRuoliSelectOptions(calciatore_id) {
      let output = [];
      const originalHtml = '<span class="label-fp">FP</span>';
      for (const key in Constants.RUOLO) {
        const ruolo_id = Constants.RUOLO[key];
        const ruoloOriginale = this.calciatoriOriginal[calciatore_id].ID_Ruolo;
        const extra = ruoloOriginale == ruolo_id ? originalHtml : "";
        output.push({
          text: this.ruolo(ruolo_id) + extra,
          value: ruolo_id.toString(),
        });
      }
      return output;
    },

    astaLogScartato(calciatore_id) {
      let log = {
        t: Constants.LOG_TYPE.SCARTATO,
        cid: calciatore_id,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogRemoveScartato(calciatore_id) {
      let log = {
        t: Constants.LOG_TYPE.REMOVE_SCARTATO,
        cid: calciatore_id,
      };
      return this.astaLog(log);
    },
    astaLogRemoveScartati() {
      let log = {
        t: Constants.LOG_TYPE.REMOVE_SCARTATI,
      };
      return this.astaLog(log);
    },
    astaLogAssign(calciatore_id, squadra_id, prezzo) {
      let log = {
        t: Constants.LOG_TYPE.ASSIGN,
        sid: squadra_id,
        cid: calciatore_id,
        p: prezzo,
        d1: 1,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogEdit(calciatore_id, squadra_id, prezzo, prezzoOld) {
      let log = {
        t: Constants.LOG_TYPE.EDIT,
        sid: squadra_id,
        cid: calciatore_id,
        p: prezzo,
        po: prezzoOld,
        d1: 1,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogCreditiExtra(squadra_id, crediti, creditiOld, creditiExtra) {
      let log = {
        t: Constants.LOG_TYPE.EDIT_CREDITI_EXTRA,
        sid: squadra_id,
        c: crediti,
        co: creditiOld,
        ce: creditiExtra,
        d1: 1,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogRemove(calciatore_id, squadra_id, prezzo) {
      let log = {
        t: Constants.LOG_TYPE.REMOVE,
        sid: squadra_id,
        cid: calciatore_id,
        p: prezzo,
        d1: 1,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogAllineaRoseStart() {
      let log = {
        t: Constants.LOG_TYPE.ALLINEA_ROSE_START,
        d1: 1,
      };
      return this.astaLog(log);
    },
    astaLogAllineaRoseSkip(calciatore_id, squadra_id, prezzo) {
      let log = {
        t: Constants.LOG_TYPE.ALLINEA_ROSE_SKIP,
        sid: squadra_id,
        cid: calciatore_id,
        p: prezzo,
        d1: 1,
      };
      return this.astaLog(log);
    },
    astaLogAllineaRoseEnd() {
      let log = {
        t: Constants.LOG_TYPE.ALLINEA_ROSE_END,
        d1: 1,
      };
      return this.astaLog(log);
    },
    astaLogAllineaRoseError() {
      let log = {
        t: Constants.LOG_TYPE.ALLINEA_ROSE_ERROR,
        d1: 1,
      };
      return this.astaLog(log);
    },
    astaLogRoseImported() {
      let log = {
        t: Constants.LOG_TYPE.ROSE_IMPORTED,
        d1: 1,
      };
      return this.astaLog(log);
    },
    astaLogRoseExported() {
      let log = {
        t: Constants.LOG_TYPE.ROSE_EXPORTED,
        d1: 1,
      };
      return this.astaLog(log);
    },
    // astaLogCreditiSquadra(squadra_id, prezzo, prezzoOld) {
    //   let log = {
    //     t: Constants.LOG_TYPE.CREDITI_SQUADRA,
    //     sid: squadra_id,
    //     p: prezzo,
    //     po: prezzoOld,
    //     d2: 1,
    //   }
    //   return this.astaLog(log)
    // },
    astaLogPassoForzato(squadra_id) {
      let log = {
        t: Constants.LOG_TYPE.PASSO_FORZATO,
        sid: squadra_id,
      };
      return this.astaLog(log);
    },
    astaLogCalciatoreInAsta(calciatore_id, squadra_id) {
      let log = {
        t: Constants.LOG_TYPE.CALCIATORE_IN_ASTA,
        cid: calciatore_id,
        sid: squadra_id,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogCalciatoreInAstaAnnullato(calciatore_id) {
      let log = {
        t: Constants.LOG_TYPE.CALCIATORE_IN_ASTA_ANNULLATO,
        cid: calciatore_id,
        d2: 1,
      };
      return this.astaLog(log);
    },
    astaLogRiammissioneAsta(squadra_id) {
      let log = {
        t: Constants.LOG_TYPE.RIAMMISSIONE_ASTA,
        sid: squadra_id,
      };
      return this.astaLog(log);
    },
    astaLogEsclusioneAsta(squadra_id) {
      let log = {
        t: Constants.LOG_TYPE.ESCLUSIONE_ASTA,
        sid: squadra_id,
      };
      return this.astaLog(log);
    },
    astaLogEsclusioneAstaAdmin(squadra_id) {
      let log = {
        t: Constants.LOG_TYPE.ESCLUSIONE_ASTA_ADMIN,
        sid: squadra_id,
        d1: 1,
      };
      return this.astaLog(log);
    },
    astaLogRoundStart() {
      let log = {
        t: Constants.LOG_TYPE.ROUND_START,
      };
      return this.astaLog(log);
    },
    astaLogRoundPause() {
      let log = {
        t: Constants.LOG_TYPE.ROUND_PAUSE,
      };
      return this.astaLog(log);
    },
    astaLogRoundStop() {
      let log = {
        t: Constants.LOG_TYPE.ROUND_STOP,
      };
      return this.astaLog(log);
    },

    astaLog(log) {
      return db.pushAstaLog(log);
    },
    wait(ms) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    primoRuoloDisponibile: function () {
      for (let ruolo = 1; ruolo <= 4; ruolo++) {
        // CI SONO CALCIATORI SVINCOLATI IN ruolo
        if (_.size(this.svincolati(ruolo, "")) > 0) {
          return ruolo;
        }
      }
      return 0;
    },
    checkAllineamentoRose(forceDialogOnResponse = false) {
      db.emit("checkAllineamentoRose", forceDialogOnResponse);
    },
    promptImportRose() {
      db.emit("showImportRose");
    },
    promptSaveRose() {
      db.emit("showSaveRose");
    },
    promptBeforeExit() {
      if (this.warnBeforeUnload) {
        return "Vuoi davvero uscire?";
      }
    },
    promptEditCreditiSquadra(id_squadra) {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }

      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }
      let crediti = this.asta_squadre[id_squadra].crediti;
      db.emit("showEditValore", id_squadra, crediti);
    },
    canEditCalciatoreAssegnato(calciatore) {
      return this.admin && calciatore && calciatore.i == 0;
    },
    promptEditCalciatoreAssegnato(id_squadra, prezzo, id_calciatore) {
      if (this.isAstaInCorso) {
        db.emit(
          "swalAstaInCorso",
          "E' possibile modificare il prezzo di acquisto di un calciatore solo dopo aver fermato l'asta"
        );
        return;
      }

      db.emit("showEditValore", id_squadra, prezzo, id_calciatore);
    },
    promptRemoveCalciatoreAssegnato(id_calciatore, id_squadra, prezzo) {
      if (this.isAstaInCorso) {
        db.emit(
          "swalAstaInCorso",
          "E' possibile rimettere calciatori tra gli svincolati solo dopo aver fermato l'asta"
        );
        return;
      }

      db.emit("swalRemoveCalciatoreAssegnato", {
        id_calciatore: id_calciatore,
        id_squadra: id_squadra,
        prezzo: prezzo,
      });
    },
    // gotoPagamento_OLD: function() {
    //   let os = this.user_claims.os;
    //   let ID_Lega = this.asta_info.id;
    //   let maxSquadre = this.asta_info.lega.maxSquadre;
    //   try {
    //     if (os == 'apple') {
    //       window.webkit.messageHandlers.showPurchaseAlert.postMessage(maxSquadre.toString());
    //     } else if (os == 'android') {
    //       Android.showPurchaseAlert(maxSquadre.toString());
    //     } else if (os == 'windows' || os == 'wphone') {
    //       window.location = "https://bridge.bridge/showPurchaseAlert";
    //     } else {
    //       let url = Config.HOST + "/asta-live/sblocca/" + ID_Lega;
    //       let win = window.open(url, '_blank');
    //       win.focus();
    //     }
    //   } catch (err) {
    //     let url = Config.HOST + "/asta-live/sblocca/" + ID_Lega;
    //     let win = window.open(url, '_blank');
    //     win.focus();
    //     console.log(err);
    //   }
    // },
    getAstaRuoliSelectOptions() {
      let output = [];
      for (const key in Constants.TIPO_RUOLI) {
        const tipo_ruoli = Constants.TIPO_RUOLI[key];
        output.push({
          text: tipo_ruoli.toUpperCase(),
          value: tipo_ruoli,
        });
      }
      return output;
    },
    getAstaModesSelectOptions() {
      let output = [];
      for (const key in Constants.ASTA_MODE) {
        const asta_mode = Constants.ASTA_MODE[key];
        output.push({
          text: this.getAstaModeName(asta_mode),
          value: asta_mode,
        });
      }
      return output;
    },
    getAstaModeName: function (asta_mode) {
      switch (asta_mode) {
        case Constants.ASTA_MODE.POKER:
          return "Asta Poker";
        case Constants.ASTA_MODE.ASSEGNA:
          return "Admin Assegna";
        case Constants.ASTA_MODE.SELVAGGIA:
          return "Asta Selvaggia";
        case Constants.ASTA_MODE.BUSTA_CHIUSA:
          return "Busta Chiusa";
        default:
          return "N/A";
      }
    },
    getAstaModeShortDescr: function (asta_mode) {
      switch (asta_mode) {
        case Constants.ASTA_MODE.POKER:
          return "Come a poker si rilancia/passa <b>seguendo l'ordine</b> intorno al tavolo virtuale";
        case Constants.ASTA_MODE.ASSEGNA:
          return "Non è una vera e propria asta: <b>l'admin assegna</b> arbitrariamente tutti i calciatori";
        case Constants.ASTA_MODE.SELVAGGIA:
          return "Asta classica con offerte tutte insieme <b>simultaneamente</b>.";
        case Constants.ASTA_MODE.BUSTA_CHIUSA:
          return "Prepara la busta entro i <b>secondi/minuti</b> impostati. Per un calciatore alla volta.";
        default:
          return "N/A";
      }
    },
    getAstaModeLongDescr: function (asta_mode) {
      switch (asta_mode) {
        case Constants.ASTA_MODE.POKER:
          return `Uno alla volta in senso orario i partecipanti potranno o
          fare la loro offerta o passare. Una volta passato non si
          può più rientrare nell'asta per quel calciatore.
          <br />Quando tutti passano e rimane solo l'offerta di un
          partecipante, il calciatore viene assegnato.`;
        case Constants.ASTA_MODE.ASSEGNA:
          return `Fa tutto l'amministratore d'asta: assegna a uno a uno i
          calciatori alle varie squadre.
          <br />Questa modalità l'abbiamo pensata per chi fa l'asta a casa incontrandosi
          con gli amici e non ha bisogno di un tool online per permettere offerte
          ma vuole un tool dove i partecipanti possano essere
          aggiornati in tempo reale su rose, crediti e offerte massime possibili.`;
        case Constants.ASTA_MODE.SELVAGGIA:
          return `La classica asta! :) Tutti possono fare offerte (o
            passare)... contemporaneamente. <br />Quando si fa
            un'offerta più alta delle altre, il timer riparte per
            poter dare a ciascun partecipante la possibilità di alzare
            l'offerta. <br />Se invece di fare un'offerta si clicca
            "Passo" non si potranno poi più fare offerte per quel
            calciatore. <br />Alla scadenza dei timeout, se non si è
            fatta un'offerta, il sistema forza un "Passo".
            <br />Quando rimane solo l'offerta di un partecipante, il
            calciatore viene assegnato.`;
        case Constants.ASTA_MODE.BUSTA_CHIUSA:
          return `Ogni partecipante prepara la sua offerta in busta chiusa
          (oppure "passa") per il calciatore chiamato in quel
          momento.
          <br />Al termine del timeout si aprono le buste e il
          calciatore viene assegnato a chi ha fatto l'offerta più
          alta e si passa al calciatore successivo. <br /><br />
          PS: Se all'apertura delle buste ci dovessero
          essere più partecipanti ad aver hatto l'offerta maggiore,
          si procede in un secondo round in cui (solo) i vincitori
          del primo round partecipano.<br />
          E così via finchè non rimane una sola offerta più alta.
          <br />
          <br />PS: E se al secondo round tutti confermano la stessa offerta del
          primo round?. <br />In questi casi il sistema, per evitare uno stallo,
          assegnerà il calciatore al partecipante che aveva fatto + velocemente
          l'offerta.`;
        default:
          return "N/A";
      }
    },
    getAstaModeCss: function (asta_mode) {
      switch (asta_mode) {
        case Constants.ASTA_MODE.POKER:
          return "asta-poker";
        case Constants.ASTA_MODE.ASSEGNA:
          return "asta-assegna";
        case Constants.ASTA_MODE.SELVAGGIA:
          return "asta-selvaggia";
        case Constants.ASTA_MODE.BUSTA_CHIUSA:
          return "asta-busta-chiusa";
        default:
          return "N/A";
      }
    },
    isSpeaker(squadra_id) {
      if (this.mode_poker) {
        return (
          this.asta_round.speaker == squadra_id &&
          this.calciatoreInAsta !== null
        );
      }
      return false;
    },
    staScegliendo(squadra_id) {
      return (
        this.running &&
        this.asta_round.chooser == squadra_id &&
        this.calciatoreInAsta == null
      );
    },
    haScelto(squadra_id) {
      return (
        this.running &&
        this.asta_round.chooser == squadra_id &&
        this.calciatoreInAsta !== null
      );
    },
    acquistabiliPerRuolo(ruolo) {
      if (!ruolo) return false;
      if (this.asta_info.lega.nRuoli.op == "illimitati") return "&#8734;";
      return this.asta_info.lega.nRuoli[Helpers.ruoloLega(ruolo)];
    },
    prefixAcquistabiliPerRuolo() {
      if (this.asta_info && this.asta_info.lega && this.asta_info.lega.nRuoli) {
        let op = this.asta_info.lega.nRuoli.op;
        if (op == "illimitati") return "";
        if (op == "<=") return "massimo";
        if (op == ">=") return "almeno";
        if (op == "=") return "";
      } else {
        return false;
      }
    },
    acquistiCompletati(id_ruolo, id_squadra) {
      if (!id_ruolo) return false;
      if (
        this.asta_info.lega.nRuoli.op == "illimitati" ||
        this.asta_info.lega.nRuoli.op == ">="
      ) {
        // un minimo di o esattamente
        return false;
      } else {
        // esattamente o un massimo di
        return (
          this.asta_info.lega.nRuoli[Helpers.ruoloLega(id_ruolo)] <=
          this.acquistiPerRuolo(id_ruolo, id_squadra)
        );
      }
    },
    acquistiPerRuolo(id_ruolo, id_squadra) {
      if (
        this.asta_squadre[id_squadra] &&
        this.asta_squadre[id_squadra].acquisti
      ) {
        return this.asta_squadre[id_squadra].acquisti[id_ruolo] || 0;
      }
      return 0;
    },
    async deactivateSquadra(squadra_id) {
      let squadreToDeactivate = [];
      let squadra = this.asta_squadre[squadra_id];
      // solo se ancora attiva
      if (squadra && squadra.active == 1) {
        const ruolo_da_chiamare = this.asta_settings.ruolo_da_chiamare;
        if (
          (ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE &&
            squadra.isRosaCompleta) ||
          squadra.isRuoloCompleto[ruolo_da_chiamare]
        ) {
          squadreToDeactivate.push(squadra);
        }
      }
      if (squadreToDeactivate.length != 0) {
        await db.updateSquadreActive(squadreToDeactivate, 0);
        if (squadra_id == this.adminUid) {
          db.emit("swalAdminEscluso");
        }
      }
      return squadreToDeactivate;
    },

    async reactivateSquadre(squadra_id) {
      let squadreToActivate = [];
      let squadra = this.asta_squadre[squadra_id];
      // solo se ancora attiva
      if (squadra && squadra.active == 0) {
        const ruolo_da_chiamare = this.asta_settings.ruolo_da_chiamare;
        if (
          (ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE &&
            !squadra.isRosaCompleta) ||
          !squadra.isRuoloCompleto[ruolo_da_chiamare]
        ) {
          squadreToActivate.push(squadra);
        }
      }

      // loop solo sulle active
      // for (let [squadra_id, squadra] of Object.entries(this.asta_squadre)) {
      // loopa solo le non attive
      // if (squadra && squadra.active == 0) {
      //   // controlla se ha completato la rosa
      //   let activate = false
      //   for (let id_ruolo of this.ruoli_array) {
      //     if (!this.acquistiCompletati(id_ruolo, squadra_id)) {
      //       activate = true
      //       // esci dal loop dei ruoli
      //       continue;
      //     }
      //   }
      //   if (activate) {
      //     squadreToActivate.push(squadra)
      //   }
      // }
      // }
      if (squadreToActivate.length != 0) {
        await db.updateSquadreActive(squadreToActivate, 1);
      }
      return squadreToActivate;
    },

    preConfirmApiCall() {
      // delego al server
      // if (!this.admin) {
      //   // workaround senza squadre!!!
      //   if (_.size(this.asta_squadre) > 0) {
      //     Swal.showValidationMessage("Azione permessa solo all'amministratore d'asta");
      //     return false;
      //   }
      // }
      if (this.isAstaInCorso) {
        Swal.showValidationMessage(
          "Asta in corso. Stoppa l'asta prima di compiere questa azione"
        );
        return false;
      }
    },
    handleApiCall(endpoint, apiName = null) {
      let params = {
        params: {
          uid: this.user_claims.fp_uid,
          sessid: this.user_claims.fp_sessid,
          token: Config.API_TOKEN,
          ID_Asta: this.asta_info.id,
        },
      };
      this.$Progress.start();
      this.$http
        .get(Config.API_ENDPOINT + endpoint, params)
        .then((response) => {
          // Success.
          this.$Progress.finish();
          let json = response.body;
          Swal.fire({
            title: "AstaLive",
            html: json.msg,
            icon: json.status === 1 ? "success" : "error",
          });
          db.emit("handleApiCallSuccess", apiName);
        })
        .catch((err) => {
          this.$Progress.fail();
          Swal.fire({
            title: "AstaLive",
            html: err.statusText,
            icon: "error",
          });
        });
    },
    getPrezzoAsta(maxSquadre) {
      return Config.PREZZI.find((obj) => obj.legaDa === maxSquadre).prezzo;
    },
    getPaypalButtonId(maxSquadre) {
      return Config.PREZZI.find((obj) => obj.legaDa === maxSquadre).buttonId;
    },
    getRowsPrezzi() {
      let rows = [];
      for (var i = 0; i < Config.PREZZI.length; i++) {
        const prezzo = Config.PREZZI[i].prezzo;
        const legaDa = Config.PREZZI[i].legaDa;
        if (Config.STANDALONE || legaDa % 2 === 0) {
          const equivalente = (prezzo / legaDa).toFixed(2);
          const row = {
            legaDa: legaDa,
            prezzo: prezzo + " €",
            comment: "Solo ~ " + equivalente + " € / persona!",
          };
          rows.push(row);
        }
      }
      return rows;
    },
    getUrlPagamento(asta_id) {
      const resolvedPath = router.resolve({
        name: "pagamento",
        params: { asta_id: asta_id },
      }).href;

      return (
        window.location.origin +
        window.location.pathname +
        window.location.search +
        resolvedPath
      );
    },

    calciatori_filter(selectedRuolo, calciatori) {
      // console.log(calciatori)

      // let aaa = _.filter(calciatori, function(calciatore) {
      //   return (selectedRuolo === 0 || parseInt(calciatore.ID_Ruolo) === selectedRuolo)
      // })

      // console.log('aaa', aaa)

      // let bbb = _.orderBy(aaa, [function(calciatore) {
      //   return calciatore.calciatore;
      // }], 'asc');

      // console.log('bbb', bbb)

      return _.orderBy(
        _.filter(calciatori, function (calciatore) {
          return (
            (selectedRuolo === 0 ||
              parseInt(calciatore.ID_Ruolo) === selectedRuolo) &&
            parseInt(calciatore.ID_Club) != 0
          );
        }),
        [
          function (calciatore) {
            return calciatore.calciatore;
          },
        ],
        "asc"
      );
    },
    getPresenceClass(presence) {
      return {
        online: presence == Constants.PRESENCE_STATES.ONLINE,
        idle:
          presence == Constants.PRESENCE_STATES.IDLE ||
          presence == Constants.PRESENCE_STATES.AWAY ||
          presence == Constants.PRESENCE_STATES.PENDING,
        offline:
          presence == Constants.PRESENCE_STATES.RESET ||
          presence == Constants.PRESENCE_STATES.OFFLINE ||
          presence == "" ||
          presence == null,
      };
    },
    initAnnoStats() {
      let annoStats = localStorage.getItem(Constants.LS_ANNO_STATS);
      // controlla se quello salvato esiste tra i disponibili
      if (!annoStats || !this.anniStats.includes(annoStats)) {
        if (this.anniStats.length > 0) {
          annoStats = this.anniStats[0];
        }
      }
      return this.$store.dispatch("setAnnoStats", annoStats);
    },
  },
  computed: {
    tipoRuoli() {
      return this.asta_settings.tipo_ruoli || Constants.TIPO_RUOLI.CLASSIC;
    },
    mantra() {
      return this.tipoRuoli == Constants.TIPO_RUOLI.MANTRA;
    },
    classic() {
      return this.tipoRuoli == Constants.TIPO_RUOLI.CLASSIC;
    },
    asta_mode_name: function () {
      return this.getAstaModeName(this.asta_settings.mode);
    },
    asta_mode: function () {
      return this.asta_settings.mode;
    },
    admin: function () {
      // se adminUid non esiste è sempre false
      if (this.adminUid) {
        return this.adminUid == this.user_uid;
      }
      return false;
    },
    adminPermission() {
      return this.asta_info.adminPermission || Constants.ADMIN_PERMISSION.ANYONE;
    },
    adminLegaUid() {
      return this.asta_lega_info && this.asta_lega_info.adminLega
        ? this.asta_lega_info.adminLega
        : "";
    },
    adminDivisioneUid() {
      const ID_Divisione = this.asta_info && this.asta_info.lega
        ? this.asta_info.lega.ID_Divisione
        : null;
      const divisioni = this.asta_lega_info && this.asta_lega_info.divisioni
        ? this.asta_lega_info.divisioni
        : {};
      const divisione = ID_Divisione != null ? divisioni[ID_Divisione] : null;
      return divisione ? divisione.adminDivisione || "" : "";
    },
    hasDivisioni() {
      return !!(this.asta_lega_info && this.asta_lega_info.hasDivisioni);
    },
    adminLegaDivisioneLabel() {
      return this.hasDivisioni
        ? "amministratore di lega o divisione"
        : "amministratore di lega";
    },
    isAdminLega() {
      return !!this.adminLegaUid && this.adminLegaUid == this.user_uid;
    },
    isAdminDivisione() {
      return !!this.adminDivisioneUid && this.adminDivisioneUid == this.user_uid;
    },
    permissionAdminLegaDivisione() {
      if (Config.STANDALONE) return false;
      if (this.isAdminLega) return true;
      return this.hasDivisioni && !!this.adminDivisioneUid && this.isAdminDivisione;
    },
    canChangeAdminAsta() {
      if (Config.STANDALONE) {
        return this.isAdminSet ? this.admin : !!this.my_squadra;
      }

      if (this.permissionAdminLegaDivisione) return true;
      if (this.adminPermission == Constants.ADMIN_PERMISSION.ADMIN_LEGA_DIVISIONE) return false;
      if (this.adminPermission == Constants.ADMIN_PERMISSION.ADMIN_ASTA) return this.admin;
      return !!this.my_squadra;
    },
    isAdminSet() {
      return !!this.adminUid && this.adminUid != "_";
    },
    adminUid() {
      // return "_1"; // per debuggare
      // può non esistere
      if (_.isObject(this.asta_info.admin)) {
        return this.asta_info.admin.uid;
      } else {
        return this.asta_info.admin || null;
      }
    },
    adminUsername() {
      // può non esistere
      if (_.isObject(this.asta_info.admin)) {
        return this.asta_info.admin.name;
      } else {
        if (this.asta_info.admin) {
          if (this.asta_squadre[this.asta_info.admin]) {
            return this.asta_squadre[this.asta_info.admin].name;
          } else {
            return "uid" + this.asta_info.admin;
          }
        } else {
          return "";
        }
      }
    },
    adminPresence() {
      return this.asta_online[this.adminUid];
    },
    adminPresenceClass() {
      return this.getPresenceClass(this.adminPresence);
    },
    premium: function () {
      return this.asta_info.premium == 1;
    },
    not_running: function () {
      return this.asta_settings.status == Constants.ASTA_STATUS.NOT_RUNNING;
    },
    running: function () {
      return this.asta_settings.status == Constants.ASTA_STATUS.RUNNING;
    },
    is_calciatore_in_asta: function () {
      return (
        this.asta_round.calciatoreInAsta !== null &&
        this.asta_round.calciatoreInAsta !== undefined
      );
    },
    isAstaInCorso() {
      if (this.mode_assegna) {
        return this.is_calciatore_in_asta;
      }
      return this.running || this.is_calciatore_in_asta;
    },
    mode_poker: function () {
      return this.asta_settings.mode == Constants.ASTA_MODE.POKER;
    },
    mode_assegna: function () {
      return this.asta_settings.mode == Constants.ASTA_MODE.ASSEGNA;
    },
    mode_selvaggia: function () {
      return this.asta_settings.mode == Constants.ASTA_MODE.SELVAGGIA;
    },
    mode_bustachiusa: function () {
      return this.asta_settings.mode == Constants.ASTA_MODE.BUSTA_CHIUSA;
    },
    mode_random: function () {
      return this.asta_settings.random_mode == Constants.RANDOM_MODE.ENABLED;
      //return (this.asta_settings.mode == Constants.ASTA_MODE.ASSEGNA || this.asta_settings.ch_mode == Constants.CHOOSER_MODE.ADMIN) && this.asta_settings.random_mode == Constants.RANDOM_MODE.ENABLED;
    },
    calciatoreInAsta() {
      return this.asta_round.calciatoreInAsta;
    },
    ruoloCalciatoreInAsta() {
      if (this.calciatoreInAsta && this.calciatori[this.calciatoreInAsta]) {
        return this.calciatori[this.calciatoreInAsta].ID_Ruolo;
      } else {
        return null;
      }
    },
    ruoloCalciatoreInAstaCompletato() {
      return this.acquistiCompletati(this.ruoloCalciatoreInAsta, this.user_uid);
    },
    _() {
      return _;
    },
    ...Vuex.mapGetters([
      "asta_info",
      "asta_lega_info",
      "asta_round",
      "asta_online",
      "asta_settings",
      "asta_squadre",
      "my_squadra",
      "asta_squadre_active",
      "user_uid",
      "user_claims",
      "svincolati",
      "calciatori",
      "calciatoriOriginal",
      "anniStats",
      "asta_id",
      "is_mobile",
    ]),
    Config: function () {
      return Config;
    },
    Constants: function () {
      return Constants;
    },
    Helpers: function () {
      return Helpers;
    },
    ie() {
      return (
        navigator.appName == "Microsoft Internet Explorer" ||
        !!(
          navigator.userAgent.match(/Trident/) ||
          navigator.userAgent.match(/rv:11/)
        ) ||
        (typeof $.browser !== "undefined" && $.browser.msie == 1)
      );
    },
    onMobile(os = null) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (os == "android") {
        return /Android/i.test(userAgent);
      } else if (os == "apple") {
        return /iPhone|iPad|iPod/i.test(userAgent);
      } else {
        return /iPhone|iPad|iPod|Android/i.test(userAgent);
      }
    },
  },
  mounted() {
    // console.log("--> Mixins mounted.");
  },
  destroyed() {
    // console.log("<-- Mixins destroyed.");
  },
};
